import { createSlice, createSelector } from "@reduxjs/toolkit";
import CollectionItem from "../../../models/CollectionItem";

// TODO: Could the "loader" part of these slices be inherited somehow? (eg. a base class)

// TODO: How do I differentiate between data: null because it's not loaded yet, and data: null because it's not found?

const initialState = {
    status: "idle",
    latestRequestTimestamp: null,
    data: null,
};

const collectionItemSlice = createSlice({
    name: "collectionItem",
    initialState,
    reducers: {
        resetCollectionItem: (state, action) => initialState,

        requestStarted: (state, action) => {
            state.status = "loading";
            state.latestRequestTimestamp = action.payload;
        },
        requestSucceeded: (state, action) => {
            if (action.payload.timestamp === state.latestRequestTimestamp) {
                state.status = "idle";
                state.latestRequestTimestamp = null;
                state.data = { ...action.payload.data };
            }
        },
    },
});

/**
 * Add actions
 */

export const setCollectionItem = (id) => async (dispatch, getState) => {
    const timestamp = Date.now();

    dispatch(collectionItemSlice.actions.requestStarted(timestamp));

    const data = await CollectionItem.find(id);

    dispatch(
        collectionItemSlice.actions.requestSucceeded({
            data,
            timestamp,
        })
    );
};

export const { resetCollectionItem } = collectionItemSlice.actions;

/**
 * Add selectors (memoised to prevent re-renders when unrelated state changes)
 */

const selectCollectionItemData = (state) => state.collectionItem.data;
export const getCollectionItem = createSelector(
    [selectCollectionItemData],
    (data) => (data ? CollectionItem.fromObject(data) : null)
);

/**
 * Export reducer
 */

export default collectionItemSlice.reducer;
